import { SaveBar as AppBridgeSaveBar } from "@shopify/app-bridge-react";
import { useBlocker, useRouter } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

const SAVE_BAR_ID = "widget-save-bar";

export function AppSaveBar({
  dirty,
  busy,
  disabled,
  onSave,
  onDiscard,
}: {
  dirty: boolean;
  busy: boolean;
  disabled: boolean;
  onSave: () => void;
  onDiscard: () => void;
}) {
  const router = useRouter({ warn: false });
  const { t } = useTranslation();
  const inactive = !dirty || busy;
  return (
    <>
      {router ? <SaveBarNavigationGuard dirty={dirty} busy={busy} /> : null}
      <AppBridgeSaveBar id={SAVE_BAR_ID} open={dirty}>
        {/* React 会丢掉未知属性的布尔值，App Bridge 只认 DOM 属性，所以传空字符串。 */}
        <button
          type="button"
          variant="primary"
          disabled={inactive || disabled}
          {...(busy ? { loading: "" } : {})}
          onClick={onSave}
        >
          {t("Save")}
        </button>
        <button type="button" disabled={inactive} onClick={onDiscard}>
          {t("Discard")}
        </button>
      </AppBridgeSaveBar>
    </>
  );
}

function SaveBarNavigationGuard({ dirty, busy }: { dirty: boolean; busy: boolean }) {
  useBlocker({
    shouldBlockFn: async ({ current, next }) => {
      if (current.pathname === next.pathname) return false;
      if (busy) return true;
      if (!dirty) return false;
      try {
        await window.shopify?.saveBar?.leaveConfirmation();
        return false;
      } catch {
        return true;
      }
    },
    enableBeforeUnload: false,
  });
  return null;
}
